import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { DentalService } from '../../_service/dental.service';
import { PageEvent,MatPaginator} from '@angular/material/paginator';
import { HotTableRegisterer } from '@handsontable/angular';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-dental-orthodontist-report',
  templateUrl: './dental-orthodontist-report.component.html',
  styleUrls: ['./dental-orthodontist-report.component.css']
})
export class DentalOrthodontistReportComponent implements OnInit {
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  perpage:number=25;length:number=0;pageEvent: PageEvent; pageSizeOptions = [10,25,50,100]; pageIndex:number=0; loading = true; loaded = false;
  private hotRegisterer = new HotTableRegisterer(); id = 'hotInstance'; settings = {colHeaders: true }; hideColumn:any;

  deliveryReportLists = []; search:string; start_date:string=''; end_date:string='';  submitted = false; clinicList=[]; doctorList=[]; DeliveryStatusList=[];
  constructor(private sharedapi:SharedService, private dentalapi:DentalService) { 
    this.DeliveryStatusList=['Done','Not Done'];
    this.loadCommonData();
  }
  
  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.getTotalDeliveryReport(0,this.perpage);
  }

  dateRangeChange(date1,date2)
  {
    if(date2.value)
    {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate()
  {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  public getServerData(event:PageEvent):any
  {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getTotalDeliveryReport(event.pageIndex,event.pageSize);
  }

  resetFilters()
  {
    this.search = '';
    this.clearDate();
    this.getTotalDeliveryReport(0,25);
  }

  async loadCommonData()
  {
    await this.dentalapi.getDentalCommonData().subscribe((data:any) => {
      if(data.status)
      {
        this.doctorList = data.doctors;
        this.clinicList = data.hospitals;
      }else{
        this.doctorList = [];
        this.clinicList = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTotalDeliveryReport(pageIndex,perpage)
  {
    this.paginator.pageIndex = pageIndex; 
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
    this.loading = true;
    this.loaded = false;
    this.deliveryReportLists = [];
    await this.dentalapi.deliveryReportLists(this.paginator.pageIndex,perpage, qString).subscribe((data:any) => {
      this.length = data.totaldata;
      this.loading = false;
      this.loaded = true;
      if(data.status)
      {
          this.deliveryReportLists = data.data;
      }
      if(data.msg){
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  onBeforeChange = (hotInstance, changes) =>
  {
    let data= this.hotRegisterer.getInstance(this.id).getSourceData();
    let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3],index:hotInstance[0][0]};
    this.saveOnChange(saveData);
  }

  async saveOnChange(saveData)
  {
    this.updateSingleData(saveData);
  }

  updateSingleData(saveData){
    this.submitted = true;
    this.dentalapi.updateSingleData(saveData).subscribe((data:any) =>
    {
      this.submitted = false;
      this.sharedapi.presentToast(data.msg);
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  exportDeliveryReportList()
  {
    if(this.deliveryReportLists.length>0)
    {
      let data = [];
      let titles = [
        'Circle',
        'Patient Name',
        'Glamyo Patient Id',
        'Patient Contact Number',
        'Pro Name',
        'Total No. of Upper Aligners',
        'Total No. of Lower Aligners',
        'Received Upper Aligners',
        'Received Lower Aligners',
        'Remaining Upper Aligners',
        'Remaining Lower Aligners',
        'Aligner Dispatch Date',
        'Aligner Delivery Date',
        'Clinic Visit/VC Date',
        'Clinic Visit/VC Time',
        'Clinic Name',
        'Ortho Assign',
        'Delivery Status'
      ];
      data.push(titles);
      for(let deliveryReport in this.deliveryReportLists)
      {
        let exdata = [
          this.deliveryReportLists[deliveryReport].circle_name,
          this.deliveryReportLists[deliveryReport].lead_name,
          this.deliveryReportLists[deliveryReport].glamyo_patient_id,
          this.deliveryReportLists[deliveryReport].mobile,
          this.deliveryReportLists[deliveryReport].pro_name,
          this.deliveryReportLists[deliveryReport].upper_aligners,
          this.deliveryReportLists[deliveryReport].lower_aligners,
          this.deliveryReportLists[deliveryReport].upper_aligner_received,
          this.deliveryReportLists[deliveryReport].lower_aligner_received,
          this.deliveryReportLists[deliveryReport].remaining_upper_aligners,
          this.deliveryReportLists[deliveryReport].remaining_lower_aligners,
          this.deliveryReportLists[deliveryReport].aligner_dispatched_date,
          this.deliveryReportLists[deliveryReport].aligner_delivery_date,
          this.deliveryReportLists[deliveryReport].clinic_visit_required_date,
          this.deliveryReportLists[deliveryReport].clinic_visit_required_time,
          this.deliveryReportLists[deliveryReport].hospital_name,
          this.deliveryReportLists[deliveryReport].ortho_assign,
          this.deliveryReportLists[deliveryReport].delivery_status
        ];
        data.push(exdata)
      }

      
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'dental_delivery_report_lists_'+utc+'.xlsx');
    }else{
      this.sharedapi.presentToast('Sorry! No data found for export.');
    }
  }

}
